import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";

import AkkhorLayout from "../../layout/AkkhorLayout";
import AlertErrorForm from "../../component/AlertErrorForm";
import { HexColorPicker } from "react-colorful";
import SearchBoxModal from "../../component/SearchBoxModal";

export default function BangHangSettingsForm() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);

    const defaultdetail = {
        author_id: user.data.id,
        title: '',
        alias: '',
        text_color: '#1F2020',
        position: 0,
        status: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "banghang_settings/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            // console.log(res.data.data)
                            if (mounted) {
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, autoRefresh]
    );
    let validForm = {
        title: Yup.string().trim().nullable().required('Nhập tiêu đề').max(250, "Độ dài không quá 250 ký tự"),
        position: Yup.string().trim().nullable().required('Vui lòng nhập vị trí'),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];
            setLoading(true)
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'banghang_settings/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật pipeline thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'banghang_settings', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();

                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới pipeline thành công',
                            buttons: [{ label: 'OK' }]
                        });
                        window.location.reload()
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    return (
        <AkkhorLayout idrole="banghang_settings">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/banghang_settings">Cài đặt Trạng thái bảng hàng</Link>
                    </li>
                    <li>{id ? 'Sửa Trạng thái bảng hàng' : 'Thêm mới Trạng thái bảng hàng'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} Trạng thái bảng hàng</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-sm-4 col-12 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>

                            <div className="col-sm-4 col-12 form-group">
                                <label>Vị trí <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("position")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="position"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Màu nền</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("background_color")} autoComplete="off" />
                                <HexColorPicker className="mt-2" color={formik.values['background_color'] ? formik.values['background_color'] : "#FFF"} onChange={(e) => formik.setFieldValue('background_color', e)} />
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Màu chữ</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("text_color")} autoComplete="off" />
                                <HexColorPicker className="mt-2" color={formik.values['text_color'] ? formik.values['text_color'] : "#FFF"} onChange={(e) => formik.setFieldValue('text_color', e)} />
                            </div>
                            <div className="col-12"></div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Trạng thái bảng hàng: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("action")}>
                                    <option value="Show" >Hiển thị</option>
                                    <option value="Hide" >Không hiển thị</option>
                                    <option value="Deactive" >Không kích hoạt</option>
                                </select>
                            </div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Trạng thái hoạt động: </label>
                                <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("status")}>
                                    <option value="1" >Đang hoạt động</option>
                                    <option value="0" >Ngưng hoạt động</option>
                                </select>
                            </div>

                            <div className="col-12 mt-3" ></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{loading ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
